import { render, staticRenderFns } from "./AdminTraining.vue?vue&type=template&id=6b885ca2&scoped=true&"
import script from "./AdminTraining.vue?vue&type=script&lang=js&"
export * from "./AdminTraining.vue?vue&type=script&lang=js&"
import style0 from "./AdminTraining.vue?vue&type=style&index=0&id=6b885ca2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b885ca2",
  null
  
)

export default component.exports